import { useEffect, useState } from 'preact/hooks';

export default ({ fetchNewsItemsUrl }) => {
	const [newsitems, setNewsItems] = useState(null);

	useEffect(() => {
		if (!fetchNewsItemsUrl) {
			return;
		}

		fetch(fetchNewsItemsUrl).then(result => result.json()).then(newsitems => {
			setNewsItems(newsitems);
		});
	}, []);

	return newsitems;
};
